import React from 'react';
import { TrainingPlansSection } from '../components/TrainingPlansSection';
import { Navbar } from '../components/Navbar';
import { motion } from 'framer-motion';
import { FAQSection } from '../components/FAQSection';
import { FreeTipsSection } from '../components/FreeTipsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export const TrainingPlansLandingPage: React.FC = () => {
  return <div className="bg-black text-white min-h-screen" data-id="element-1746">
      {/* Hero section specifically for landing page */}
      <motion.section initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6
    }} className="relative pt-24 pb-12 bg-gradient-to-b from-black via-gray-900 to-black" data-id="element-1747">
        <div className="container mx-auto px-4 text-center" data-id="element-1748">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-4xl md:text-6xl font-black mb-6 leading-tight" data-id="element-1749">
            <span className="text-green-500" data-id="element-1750">TRANSFORMUJ</span> SVÉ TĚLO
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto" data-id="element-1751">
            Vyber si tréninkový plán podle své úrovně a začni vidět skutečné
            výsledky. Přesně strukturované plány s video ukázkami, které tě
            dovedou k vysněné postavě.
          </motion.p>
        </div>
      </motion.section>

      {/* Training Plans Section - without progress section */}
      <TrainingPlansSection showProgressSection={false} data-id="element-1752" />

      {/* FAQ Section */}
      <FAQSection data-id="element-1753" />

      {/* Free Tips Section - moved above Contact */}
      <FreeTipsSection data-id="element-1754" />

      {/* Contact Section */}
      <ContactSection data-id="element-1755" />

      {/* Footer */}
      <Footer data-id="element-1756" />
    </div>;
};